<template>
  <div ref="root" class="lazy-cross-selling">
    <div class="lazy-cross-selling-placeholder" style="min-height: 320px;" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: "lazy-cross-selling",

  props: {
    itemId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      observer: null,
      requested: false
    };
  },

  mounted() {
    if (App.isShopBuilder || !("IntersectionObserver" in window)) {
      this.loadContent();
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.observer.disconnect();
        this.loadContent();
      }
    }, {
      rootMargin: "400px 0px",
      threshold: 0
    });

    this.observer.observe(this.$refs.root);
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    loadContent() {
      if (this.requested) {
        return;
      }

      this.requested = true;
      fetch(`/plugin/ETCeresCoconut/cross-selling/${this.itemId}`, {
        credentials: "same-origin"
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          return response.text();
        })
        .then(content => {
          // Write only inside this component's DOM node. Updating reactive
          // state here causes the SSR root to be patched and can remove
          // sibling markup such as the footer.
          this.$el.innerHTML = content.trim();
        })
        .catch(error => {
          console.error("[LazyCrossSelling] Ladefehler:", error);
        });
    }
  }
};
</script>
